import { GripVertical, Plus } from 'lucide-react';
import { useState } from 'react';

interface TaskConnectionProps {
  showPlus?: boolean;
  onInsert?: () => void;
  isReorderMode?: boolean;
  isTrailing?: boolean;
}

export default function TaskConnection({
  showPlus = false,
  onInsert,
  isReorderMode = false,
  isTrailing = false,
}: TaskConnectionProps) {
  const [skeletonVisible, setSkeletonVisible] = useState(false);

  if (!showPlus && isTrailing) return null;

  const lineVisible = showPlus ? (!isTrailing || skeletonVisible) : true;

  return (
    <div className='flex w-fit flex-col items-center mx-auto'>
      <div className='relative flex h-[50px] w-full justify-center'>
        <div className={`h-full w-[3px] rounded-full bg-ws-border transition-opacity duration-200 ${lineVisible ? 'opacity-100' : 'opacity-0'}`} />
        <button
          onClick={onInsert}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseEnter={() => setSkeletonVisible(true)}
          onMouseLeave={() => setSkeletonVisible(false)}
          className={`absolute top-1/2 -translate-y-1/2 flex h-9 w-9 items-center justify-center rounded-full bg-ws-control-hover border border-ws-border-strong shadow-md transition-all duration-150 ${
            showPlus ? 'opacity-100 scale-100' : 'opacity-0 pointer-events-none scale-75'
          }`}
        >
          <Plus className='h-4 w-4 text-ws-text' />
        </button>
      </div>

      <div
        className={`grid transition-all duration-200 ${
          showPlus && skeletonVisible ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0 pointer-events-none'
        }`}
      >
        <div className='overflow-hidden flex flex-col items-center'>
          {isReorderMode ? (
            <div className='flex min-w-[246px] items-center gap-2'>
              <GripVertical className='h-5 w-5 shrink-0 opacity-0' />
              <div className='w-full rounded-lg border border-ws-border bg-ws-hover shadow-[0_1px_2px_rgba(0,0,0,0.05)] px-3 py-3'>
                <div className='h-5' />
              </div>
            </div>
          ) : (
            <div className='min-w-[246px] rounded-lg border border-ws-border bg-ws-hover shadow-[0_1px_2px_rgba(0,0,0,0.05)] px-4 py-3'>
              <div className='flex flex-col gap-3'>
                <div className='h-5' />
                <div className='h-9' />
              </div>
            </div>
          )}
          {!isTrailing && <div className='h-[24px] w-[3px] rounded-full bg-ws-border' />}
        </div>
      </div>
    </div>
  );
}
